import React from 'react';
import { WIDGET_NAMES } from 'constants/entity-names';
import './SsoLogoutContainer.styles.scss';
import data from 'ui/views/widgets/siteHeader/siteHeaderData.json';
import { LazyImage } from 'modules/lazy-image';



const _SsoLogoutContainer = () => {
	
	return (
		<div className="logout-ui-container">
			<div className="logout-ui-logo-container">
				<div className="ui-sso-logout-view__container__logout-form full-width">
					<div className="ui-sso-logout-view__container__logo logout-ui-logo">
						<>
							<div className='ui-sso-logout-view__container__logo'>
								<>

									<LazyImage
										preloaderClassName='ui-site-header__content__logo__preloader'
										imageClassName='ui-site-header__content__logo__img'
										src={data.logoUrl}
										alt='HealthDyne'
										rel='logo image'
									/>

								</>
							</div>
						</>
					</div>
				</div>
			</div>


			<div

				className='ui-sso-logout-view__body'
			>
		
				<span className='ui-sso-logout-view__body__title' >
					Your session has ended
				</span>

				<span className='ui-sso-logout-view__body__subTitle' >
					We appreciate your time and hope you found everything you needed.
				</span>

				<span className='ui-sso-logout-view__body__subTitle' >
				You can return to the portal anytime to review and manage member details, orders, and prescriptions.
				</span>

				<span className='ui-sso-logout-view__body__subTitle' >
					You may now close this page. Thank you for visiting the HealthDyne Clinic Portal!
				</span>


			</div>
		</div>
	);
};

export const SsoLogoutContainer = _SsoLogoutContainer;

SsoLogoutContainer.displayName = WIDGET_NAMES.SSO_LOGOUT_CONTAINER;
